// extracted by mini-css-extract-plugin
export default {"buyer":"Buyer_buyer__Y0Gvx","info":"Buyer_info__uxGf-","textInfo":"Buyer_textInfo__dXUZf"};